export class ModalServiceMockSpec {
    open() {}
}
